module.exports = __webpack_public_path__ + "static/persona-1-679e094fee2ec21ee422411272e969ce.jpg";